module.exports = __webpack_public_path__ + "img/icon-gp-128x128-03-star.c952766b.svg";